import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReleaseLicensePageRoutingModule } from './release-license-routing.module';

import { ReleaseLicensePage } from './release-license.page';
import { ComponentsModule } from '../../components/components.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    IonicModule,
    ReleaseLicensePageRoutingModule
  ],
  declarations: [ReleaseLicensePage]
})
export class ReleaseLicensePageModule {}
